module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"register_modal::close-button":"Закрыть","register_modal::save-button":"Сохранить","register_modal::save_text":"Сохранение выполнено успешно","register_modal::date_choose":"Выберите дату"},"en":{"register_modal::close-button":"Close","register_modal::save-button":"Save","register_modal::save_text":"Saved successfully","register_modal::date_choose":"Choose a date"}}')
  delete Component.options._Ctor
}
